import { useFetcher } from '@remix-run/react';

import type { ToastData } from '~/hooks/useToast';

export const SPACE_MEMBERSHIP_ACTION = '/community_space_membership';

export const spaceMembershipFetcherKey = 'community-space-membership';

export type SpaceMembershipActionData = {
  toast?: ToastData;
};

export const useSpaceMembershipFetcher = () => {
  const fetcher = useFetcher<SpaceMembershipActionData>({ key: spaceMembershipFetcherKey });
  return { fetcher };
};
